module.exports = __webpack_public_path__ + "img/home_welcome4_2.e314b575.jpg";